import { useState, useEffect } from 'react';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../api/context';
import { useFPContext } from '../../../utils/fingerprint';
import dialogs from '../../../dialogs';
import review from '../../../components/review';
import toast from '../../../utils/toast';
import Base from '../../Base';
import styles from './ReviewYotpo.module.scss';

const ReviewYotpo = ({ campaign, activity, handle }) => {

  const { token } = useAPIContext();

  const { setDialog } = dialogs.utils.useDialog();

  /*
   * data
   */

  const [ dataLoading, setDataLoading ] = useState(true);
  const [ data, setData ] = useState();

  useEffect(() => {

    api(token).v1.campaigns.activities
      .obtain({
        campaign: campaign.id,
        activity: activity.id,
      })
      .then(res => {
        setDataLoading(false);
        setData(res.body.data);
      })
      .catch(err => {
        setDataLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token, campaign.id, activity.id]);

  /*
   * submit
   */

  const { fp } = useFPContext();

  const [ submitLoading, setSubmitLoading ] = useState(false);

  const submit = (values) => {

    setSubmitLoading(true);

    fp.get().then(result => {

      api(token).v1.campaigns.activities.submit
        .post(
          {
            campaign: campaign.id,
            activity: activity.id,
          },
          {
            data_json: JSON.stringify(values),
            fingerprint: result.visitorId,
          },
        )
        .then(res => {
          setSubmitLoading(false);

          if (res.status === 200) {
            handle(res.body);
            setDialog();
          }

          if (res.status === 400) {
            toast.show(toast.KIND.ERROR, res.body);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          toast.show(toast.KIND.WARNING, err);
        });
    });
  };

  /*
   * content
   */

  const loading = dataLoading || submitLoading;

  return (
    <Base title='Yotpo'>
      <div className={styles.root}>
        {
          dataLoading &&
          <div className={styles.loading}>
            Loading...
          </div>
        }

        {
          data && (
            <>
              <div
                className={styles.instr}
                dangerouslySetInnerHTML={{
                  __html: data.instr
                }}
              />

              <Formik
                initialValues={{
                  stars: (data.result.data || {}).stars || 0,
                  title: (data.result.data || {}).title || '',
                  text: (data.result.data || {}).text || '',
                }}
                validationSchema={yup.object({
                  stars: yup.number()
                    .min(1, 'The star rating is required.')
                    .max(5, 'The star rarting is invalid.'),
                  title: yup.string()
                    .required('The review title is required.'),
                  text: yup.string()
                    .required('The review text is required.'),
                })}
                validateOnChange={false}
                onSubmit={(values, actions) => {

                  if (loading) {
                    return;
                  }

                  submit(values);

                }} >

                <Form>

                  <review.Stars
                    className={styles.stars}
                    loading={loading}
                    count={5}
                  />

                  <div className={styles.field}>
                    <label htmlFor='title'>Title</label>

                    <Field
                      id='title'
                      aria-label='title'
                      name='title'
                      type='text'
                      disabled={loading}
                    />

                    <ErrorMessage
                      className={styles.error}
                      name='title'
                      component='div'
                    />
                  </div>

                  <review.Text
                    className={styles.text}
                    loading={loading}
                    label={(
                      <>
                        Review
                        {
                          data.config.prefix && (
                            <span>
                              (Disclosure text added
                              - DO NOT REMOVE THIS TEXT
                              - You must include it when posting.)
                            </span>
                          )
                        }
                      </>
                    )}
                    prefix={data.config.prefix}
                    length={{
                      min: data.config.min_length,
                      max: data.config.max_length,
                    }}
                    nlp={{
                      include: data.config.nlp_include,
                      exclude: data.config.nlp_exclude,
                      exclude_default: data.config.nlp_exclude_default,
                    }}
                  />

                  <button
                    type='submit'
                    disabled={loading}>

                    Submit

                  </button>

                </Form>
              </Formik>
            </>
          )
        }
      </div>
    </Base>
  );
};

export default ReviewYotpo;